var _title, _style, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _mask, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGooglePlay = function SvgGooglePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "\n        google play icon\n    ")), /*#__PURE__*/React.createElement("defs", null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@media screen and (-ms-high-contrast: active) { \n            #path-2 { \n            fill: inherit; } \n            #red, #yellow, #blue, #green { \n            fill: window; stroke: windowText; stroke-width: 1; stroke-linecap: butt; } }")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-1",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "38.913%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FBDA09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFBC00"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    d: "M26.167 13.145c1.72.973 1.722 2.548 0 3.52L3.927 29.238c-1.72.973-3.114.165-3.114-1.822V2.397C.813.417 2.205-.4 3.927.574l22.24 12.57z",
    style: {
      fill: "inherit"
    }
  }), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-4",
    x1: "0%",
    x2: "69.306%",
    y1: "58.476%",
    y2: "39.083%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#01E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#01C4FF"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-5",
    x1: "20.281%",
    x2: "83.82%",
    y1: "20.102%",
    y2: "83.621%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#28D781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#02F076"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-6",
    x1: "74.488%",
    x2: "10.108%",
    y1: "17.43%",
    y2: "91.184%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F2414E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E02554"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "google-play-icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "yellow",
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "blue",
    fill: "url(#linearGradient-4)",
    d: "M.875-.01L15.55 14.666.685 29.922z",
    mask: "url(#mask-3)",
    style: {
      fill: "url(#linearGradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "green",
    fill: "url(#linearGradient-5)",
    d: "M-2.143-3.032l17.69 17.702 5.26-5.05z",
    mask: "url(#mask-3)",
    style: {
      fill: "url(#linearGradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "red",
    fill: "url(#linearGradient-6)",
    d: "M15.55 14.667l8.053 8.166L-.452 31z",
    mask: "url(#mask-3)",
    style: {
      fill: "url(#linearGradient-6)"
    }
  })))));
};
export default SvgGooglePlay;